import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { NestedTab } from "./types";

interface UseNestedTabs {
  visibleTabs: NestedTab[];
}

export interface Props {
  tabs: NestedTab[];
  redirectToFirst?: boolean;
}

export const useNestedTabs = (props: Props): UseNestedTabs => {
  const { tabs, redirectToFirst } = props;

  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const visibleTabs = tabs.filter((tab) => !tab.hidden);
  const firstUrl = visibleTabs[0]?.url;

  useEffect(() => {
    const isOnHiddenTab = tabs.find(
      (tab) => tab.hidden && pathname.startsWith(tab.url)
    );
    const isOnUnknownVisibleTab = !visibleTabs.some((tab) =>
      pathname.startsWith(tab.url)
    );

    if (
      redirectToFirst &&
      firstUrl &&
      (isOnHiddenTab || isOnUnknownVisibleTab)
    ) {
      navigate(`${firstUrl}${search}`, { replace: true });
    }
  }, [
    pathname,
    search,
    tabs,
    visibleTabs,
    redirectToFirst,
    navigate,
    firstUrl,
  ]);

  return { visibleTabs };
};
